<template>
  <BreadCrumbDetail :PageTitle="t('breadCrumb.permissionsList')" />
  <PermissionsContent />
</template>

<script lang="ts">
import { defineComponent,onMounted } from "vue";
import stateStore from "../../utils/store";
import { useI18n } from "vue-i18n";
import BreadCrumbDetail from "../../components/Common/BreadCrumbDetail.vue";
import PermissionsContent from "../../components/Settings/PermissionsContent.vue";


export default defineComponent({
  name: "PermissionsPage",
  components: {
    BreadCrumbDetail,
    PermissionsContent,
  },
  setup(){
    const { t } = useI18n();
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
    onMounted(() => {
          stateStoreInstance.show = true;
        });
       return {stateStoreInstance, t};
  }
});
</script>